<template>
  <div class="header">
    <div class="flex just-between common-width-box">
      <div class="flex">
        <div class="logo">
          <img style="object-fit: contain" class="w-h-100" :src="systemConfig.logoFile.url" alt="" />
        </div>
        <div class="flex flex-column align-center just-center header-title">
          <p>人力资源处</p>
          <p style="margin-top: 10px">党委教师工作部</p>
        </div>
      </div>
      <div class="flex">
        <div class="flex flex-column just-center">
          <div class="flex just-around app-list">
            <div class="cursor-pointer" @click="goUrl(sysConfig.recruitUrl)">{{sysConfig.recruitText ? sysConfig.recruitText : "人才招聘系统"}}</div>
            <div class="cursor-pointer" @click="goUrl(sysConfig.staffUrl)">{{sysConfig.staffText ? sysConfig.staffText : "教师个人主页"}}</div>
            <div class="cursor-pointer" @click="gotoManage">管理系统</div>
          </div>
          <div class="flex" v-if="showSearch">
            <el-input placeholder="请输入内容" v-model="keyword"></el-input>
            <el-button slot="append" icon="el-icon-search" @click="getResult" ></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-case-declarations */
export default {
  props: {
    showSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      keyword: "",
      systemConfig: {
        logoFile: {
          url: ""
        }
      },
      sysConfig: {
        recruitUrl: "",
        recruitText: "人才招聘系统",
        staffUrl: "",
        staffText: "教师个人主页"
      }
    };
  },
  methods: {
    getResult() {
      this.$router.push({
        name: 'search',
        params: {
          keyword: this.keyword
        }
      })
      // this.$emit("getResult", this.keyword);
    },
    gotoManage() {
      const { href } = this.$router.resolve({
        path: "/login",
        params: "",
      });
      window.open(href, "_blank");
    },
    getSystemConfig() {
      this.$api.index.getSystemConfig().then(res => {
        if (res.code === 200) {
          this.systemConfig = res.data;
        }
      })
    },
    getTitleName () {
      this.$api.index.getTitleName().then(res => {
        if (res.code === 200) {
          this.sysConfig = res.data
        }
      })
    },
    goUrl(url) {
      if (!url) {
        return false;
      }
      window.open(url);
    }
  },
  mounted() {
    this.getSystemConfig();
    this.getTitleName();
  },
};
</script>

<style lang='less' scoped>
  .header-title {
    width: 204px;
    margin-left: 27px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
  }

  .app-list {
    padding-left: 47px;
    width: 320px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
    white-space: nowrap;
  }

  .app-list div {
    padding: 0 10px;
    border-left: 1px solid #fff;
  }

  .app-list div:first-child {
    border: none;
  }

  /deep/ .el-input__inner {
    border-radius: 0;
    height: 34px;
    background: #ffffff;
  }

  /deep/ .el-button {
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 0;
    padding: 12px 30px 12px 20px;
    background: #c81520;
  }

  /deep/ .el-button:focus,
  .el-button:hover {
    background: #c81520;
    color: #fff;
  }

  /deep/ .el-icon-search:before {
    color: #fff;
  }
</style>
